import {
  ReportComponentDataProps,
  ReportDashboardFilters,
  ReportParamFilters,
} from '@core/reports-types';

import { getAvailableDataIntervals } from './trend-date-interval';

const applyGlobalFilters = (
  componentFilters: ReportParamFilters,
  dashboardFilters: ReportParamFilters,
): ReportParamFilters => {
  const dashboardGroups = dashboardFilters.map(d => d.group);

  return [
    ...dashboardFilters,
    ...componentFilters.filter(saved => !dashboardGroups.includes(saved.group)),
  ];
};

export const overrideComponentFilters = (
  component: ReportComponentDataProps,
  overrides: ReportDashboardFilters,
  accountCreatedAt: moment.Moment,
) => {
  const overwriteDate = overrides.dateFilter && overrides.dateFilter.dateRange;

  const filters = applyGlobalFilters(component.filters, overrides.filters);
  const dateFilter = overwriteDate ? overrides.dateFilter : component.dateFilter;

  if (overwriteDate && component.settings?.interval) {
    const availableIntervals = getAvailableDataIntervals(dateFilter, accountCreatedAt);

    return {
      ...component,
      filters,
      dateFilter,
      settings: {
        ...component.settings,
        interval: availableIntervals.shift(),
      },
    };
  }

  return {
    ...component,
    filters,
    dateFilter,
  };
};
